import { createStructuredSelector, createSelector } from 'reselect'
import { momentTimeYear } from '../../../../Utils/DateLocalizationHelper'

export const avgBatteryCycleCard = state => state.dashboard.batteryHealthBelow
export const batteriesProperties = (state) => state.user?.subscription?.batteriesProperties || [];
export const currentCulture = state => state.user.language

export const data = createSelector(
  [avgBatteryCycleCard, currentCulture, batteriesProperties],
  (avgBatHp, culture, batteriesProps) => avgBatHp.getIn(['batteryList'], []).map((row, index) => {
    const hour = momentTimeYear(row.calculatedManufactureDate, culture.slice(0, 2));
    if (!batteriesProps || batteriesProps.length === 0) {
      return {
        serialNumber: row.serialNumber,
        batteryAge: row.batteryAge,
        batteryPercentage: row.batteryPercentage,
        cycleCount: row.cycleCount,
        currentDevice: row.currentDevice,
        currentDeviceAlias: row.currentDeviceAlias,
        calculatedManufactureDate: hour,
        deviceSite: row.deviceSite,
        batterySite: row.batterySite,
        lastUpdated: row.lastUpdated
      };
    } else {
      const result = {};
      batteriesProps.forEach(prop => {
        switch (prop) {
          case 'batteryPercentage':
            result.batteryPercentage = row.batteryPercentage;
            break;
          case 'cycleCount':
            result.cycleCount = row.cycleCount;
            break;
          case 'batteryAge':
            result.batteryAge = row.batteryAge;
            break;
          default:
            result[prop] = row[prop];
            break;
        }
      });
      return {
        serialNumber: row.serialNumber,
        currentDevice: row.currentDevice,
        currentDeviceAlias: row.currentDeviceAlias,
        calculatedManufactureDate: hour,
        deviceSite: row.deviceSite,
        batterySite: row.batterySite,
        lastUpdated: row.lastUpdated,
        ...result
      };

    }
  })
);

export default createStructuredSelector({
  data
})
